export class ControlPlaneConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "staticPublicIps",
            "baseName": "staticPublicIps",
            "type": "string",
            "format": ""
        },
        {
            "name": "mongoAtlasOidc",
            "baseName": "mongoAtlasOidc",
            "type": "MongoAtlasOidc",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlPlaneConfig.attributeTypeMap;
    }
    constructor() {
    }
}
